import type {Mapper} from 'framework';
import type {WorkoutSummary} from '../../domain/workout-summary';
import type {WorkoutSummaryDto} from '../dto/workout.dto';

export class WorkoutSummaryDtoToSummaryMapper
  implements Mapper<WorkoutSummaryDto, WorkoutSummary>
{
  transform(dto: WorkoutSummaryDto): WorkoutSummary {
    return {
      id: dto.id,
      name: dto.name,
      finishedAt: String(dto.finishedAt),
      durationSeconds: dto.durationSeconds,
      totalVolumeKg: dto.totalVolumeKg,
      totalSets: dto.totalSets,
      exerciseCount: dto.exerciseCount,
    };
  }
}
